import angular from 'angular';

export default function uppercaseFirst() {
  return function link(input = '', lowerCaseRest = false) {
    if (angular.isNumber(input)) {
      return input;
    }
    return (lowerCaseRest ? input.toLowerCase() : input).replace(/^\w/g, (a) => a.toUpperCase());
  };
}
